import { Injectable,Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { AuthService } from './auth.service';

const TOKEN_HEADER_KEY = 'x-access-token';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor { 
  constructor(private injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let authService = this.injector.get(AuthService)
      let tokenizedReq = req;
      const token = authService.getToken();
      if (token != null) {
        tokenizedReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY,token) });
      }
      return next.handle(tokenizedReq);
    }
    
}


// intercept(req, next) {
//   let tokenizedReq = req.clone({
//     setheaders : {
//       Authorization : 'Bearer xx.yy.zz'
//     }
//   })

//   return next.handle(tokenizedReq);
 
// }

// intercept(req: HttpRequest<any>, next: HttpHandler) {
//   let tokenizedReq = req;
//   const token = this.token.getToken();
//   if (token != null) {
//     tokenizedReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer xx.yy.zz') });
//   }
//   return next.handle(tokenizedReq);
// }

// export const TokenInterceptorServiceProvider = [
//     { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true }
//   ];